<div mat-dialog-title>
  <h2>{{ 'patient-details.authorization-card.title' | translate }}</h2>
</div>
<mat-dialog-content>
  <mmx-prior-authorization-form
    [configuration]="configuration"
    [data]="data"
    [readonlyMode]="true"
  ></mmx-prior-authorization-form>
</mat-dialog-content>
